export const SET_FETCHING_REFERENCES = 'SET_FETCHING_REFERENCES';
export const SET_TOTAL_AMOUNT_OF_REFERENCES = 'SET_TOTAL_AMOUNT_OF_REFERENCES';
export const SET_REFERENCES_ERROR = 'SET_REFERENCES_ERROR';
export const SET_REFERENCES = 'SET_REFERENCES';
export const SET_REFERENCES_MODAL_DATA = 'SET_REFERENCES_MODAL_DATA';
export const SET_MODAL_REFERENCE_DATA_TO_SEND = 'SET_MODAL_REFERENCE_DATA_TO_SEND';